/* istanbul ignore file */
// no business logic, will cover it with TODO: cypress
import { CLASSNAME_HIDDEN } from '@vfde-brix/core';
import { getSessionStorageItemJson } from '@vfde-sails/storage';
import { ADDRESS_SESSION_STORAGE_KEY, CONFIRMATION_NAME_ID, REPRESENTED_BY_CONTAINER_ID } from 'Container/glasfaserRegistration/constant';
import { IHouseAddressData, ILandUseFormData, IVfpResult, StateProps } from 'Container/glasfaserRegistration/interface';
import { showSuccessNotification, showTryAgainNotification } from './renderNotification';

const updateLandUseForm = (newState: StateProps): void => {

    const registrationData = newState.registrationData as ILandUseFormData;
    const { firstname, lastname, representedByCheck } = registrationData;

    // Hide or show represented by form section
    if (representedByCheck !== undefined) {
        const representsByContainer = document.getElementById(REPRESENTED_BY_CONTAINER_ID);
        representsByContainer.classList.toggle(CLASSNAME_HIDDEN, !representedByCheck);
    }

    // Fill name in confirmation checkbox agreement
    if (firstname && lastname) {
        const confirmationNameSpan = document.getElementById(CONFIRMATION_NAME_ID);
        confirmationNameSpan.innerHTML = `${firstname} ${lastname}`;
    }

    if (newState.error) {
        showTryAgainNotification();
    }

    if ('ok' === newState.responseData) {
        showSuccessNotification();
    }
};

const setAddressDataFromSession = (action): void => {

    // ****** WARNING - MOCK VALUES - START *******
    // console.warn('MOCK VALUES ARE BEING USED!');
    // const vfpResult = require('../__test__/__mock__/vfp-result-fixture-2.json');
    // setSessionStorage(ADDRESS_SESSION_STORAGE_KEY, vfpResult);
    // ****** WARNING - MOCK VALUES - END *******

    const addressSessionObject: IVfpResult = getSessionStorageItemJson(ADDRESS_SESSION_STORAGE_KEY);
    setAddressInputValues(addressSessionObject);

    action.readSessionStorage(getAddressDataObject(addressSessionObject));
};

const setAddressInputValues = (addressObject: IVfpResult): void => {
    setInputAndDisable('input-street', addressObject.REF_STR);
    setInputAndDisable('input-house-number', addressObject.REF_HNR);
    setInputAndDisable('input-zipcode', addressObject.REF_PLZ);
    setInputAndDisable('input-city', addressObject.REF_ORT);
};

const setInputAndDisable = (inputId: string, value: string): void => {
    const input = document.getElementById(inputId) as HTMLInputElement;
    input.focus();
    input.value = value || '';
    input.disabled = true;
    window.scrollTo(0, 0);
    input.blur();
};

const getAddressDataObject = (vfpResult: IVfpResult): IHouseAddressData => ({
    zipcode: vfpResult.REF_PLZ,
    city: vfpResult.REF_ORT,
    street: vfpResult.REF_STR,
    houseNumber: vfpResult.REF_HNR,
});

export { setAddressDataFromSession, updateLandUseForm };

